import { useTranslation } from '@mint-lib/i18n';

import { UsersAndItemId } from './UserCascadeCell.types.js';

const UserCascadeCell = (value: UsersAndItemId) => {
  const { t } = useTranslation('@myn/permissions');
  const isEmpty = value.users.length === 0;

  return <div>{isEmpty ? t('No user assigned') : value.users.length}</div>;
};

export default UserCascadeCell;
